/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactExport from 'react-export-excel';
import { useTranslation } from 'react-i18next';
import c from '../../../constant';
import useStore from '../../../store';
import { fileNameEWS } from '../Miscellaneous/export';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getYear } from '../../../containers/EarlyWarning/utils';
import { useEffect, useMemo } from 'react';
import { useEffectEvent } from 'react';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcelSummarizedReportIR({ object = null, ...props }) {
	const { t } = useTranslation();
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const years = urlParams.get('years') ?? new Date().getFullYear();
	const currentLang = useStore((state) => state.currentLang);

	const showYear = (() => {
		if (!years) return `${getYear(null)}`;

		let parsed;

		try {
			parsed = JSON.parse(years);
		} catch (e) {
			return `${getYear(null)}`;
		}

		if (!Array.isArray(parsed)) {
			return `${getYear(parsed)}`;
		}

		const ys = parsed
			.map((s) => parseInt(s))
			.sort((a, b) => a - b)
			.map((p) => getYear(p));

		return ys.join(' - ');
	})();

	return (
		<>
			<Box {...props}>
				<ExcelFile
					filename={fileNameEWS(`Annually IR Summarized Report_${showYear}`, null, null)}
					element={
						<>
							<Button
								leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
								colorScheme="gray"
								variant="solid"
								size="sm"
								borderRadius={c.borderRadius}
								border="1px solid #bdc3c7"
							>
								{t('Export')}
							</Button>
						</>
					}
				>
					{(Array.isArray(object) ? object : [object])?.map((object, i) => {
						if (!object?.labels?.length) return null;

						const data = object?.labels?.map((label, j) => {
							return {
								title: currentLang === 'kh' ? label?.titleKhmer : label?.titleEnglish,
								valueKHR_y1: object.tables?.[0]?.tableCells?.[j]?.[0]?.value ?? '',
								valueFC_y1: object.tables?.[0]?.tableCells?.[j]?.[1]?.value ?? '',
								valueTotal_y1: object.tables?.[0]?.tableCells?.[j]?.[2]?.value ?? '',
								valueUSD_y1: object.tables?.[0]?.tableCells?.[j]?.[3]?.value ?? '',
								valuePercent_y1: object.tables?.[0]?.tableCells?.[j]?.[4]?.value ?? '',
							};
						});

						return (
							<ExcelSheet key={i} data={data} name={object?.code || `Sheet ${i + 1}`}>
								<ExcelColumn label={t('Label')} value="title" />
								<ExcelColumn
									label={currentLang === 'kh' ? `${showYear}_ទឹកប្រាក់_ប្រាក់រៀល_(គិតជា លានរៀល)` : `${showYear}_AMOUNT_KHR_In Million KHR`}
									value="valueKHR_y1"
								/>
								<ExcelColumn
									label={
										currentLang === 'kh'
											? `${showYear}_ទឹកប្រាក់_រូបិយវត្ថុអន្តរជាតិ_(គិតជា លានរៀល)`
											: `${showYear}_AMOUNT_Foreign Currency_In Million KHR`
									}
									value="valueFC_y1"
								/>
								<ExcelColumn
									label={currentLang === 'kh' ? `${showYear}_ទឹកប្រាក់_សរុប_(គិតជា លានរៀល)` : `${showYear}_AMOUNT_Total_In Million KHR`}
									value="valueTotal_y1"
								/>
								<ExcelColumn
									label={currentLang === 'kh' ? `${showYear}_ទឹកប្រាក់_ដុល្លារ​អាមេរិក` : `${showYear}_AMOUNT_USD`}
									value="valueUSD_y1"
								/>
								<ExcelColumn
									label={currentLang === 'kh' ? `${showYear}_ភាគរយនៃទ្រព្យសកម្មវិនិយោគ` : `${showYear}_Percentage of Invested Asset`}
									value="valuePercent_y1"
								/>
							</ExcelSheet>
						);
					})}
				</ExcelFile>
			</Box>
		</>
	);
}
